import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { ElementLogger } from '../../base/logger';
import { DEV_MODE } from '../../global/env';
import { scrimElementStyles } from './styles';
export const SCRIM_ELEMENT_TAG_NAME = 'vds-scrim';
/**
 * A darkened overlay (gradient) that covers the video to enable controls placed on it to be more
 * visible. The gradient is a base64 pre-defined image for the best possible gradient transition.
 * One caveat is it has a fixed height of 258px. Change the background-image to your liking or use
 * CSS to override the `gradient` part.
 *
 * @tagname vds-scrim
 * @csspart gradient - The gradient element.
 * @slot - Used to pass content inside the gradient.
 */
export class ScrimElement extends LitElement {
    constructor() {
        super(...arguments);
        // -------------------------------------------------------------------------------------------
        // Properties
        // -------------------------------------------------------------------------------------------
        /* c8 ignore next */
        this._logger = DEV_MODE && new ElementLogger(this);
        /**
         * The direction of the gradient.
         */
        this.direction = 'up';
    }
    static get styles() {
        return [scrimElementStyles];
    }
    // -------------------------------------------------------------------------------------------
    // Lifecycle
    // -------------------------------------------------------------------------------------------
    render() {
        return html `
      <div id="gradient" part="gradient">${this._renderGradientSlot()}</div>
    `;
    }
    _renderGradientSlot() {
        return html `<slot></slot>`;
    }
}
__decorate([
    property({ reflect: true })
], ScrimElement.prototype, "direction", void 0);
